import React from "react";
import ReactDOM from "react-dom";

import UserApp from "./UserApp";

// Opt-in to Webpack hot module replacement
if (module.hot) module.hot.accept();

ReactDOM.render(<UserApp />, document.getElementById("root"));
